import { IMapNamesShortcut } from "@/core/composables/types";
import type { IF360DateUtils } from "@/core/plugins/date/F360DateUtils";
import {
  type EShortcutsDate,
  type IDateRange,
  type IShortcutHandler,
  EShortcutsDateIndicadores
} from "./types";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class ShortcutIndicadoresHandler
  implements IShortcutHandler<EShortcutsDateIndicadores>
{
  shortcuts;
  shortcutNames: IMapNamesShortcut<EShortcutsDateIndicadores>;
  private dateUtils: IF360DateUtils;

  constructor(@inject(DITypes.DATE_UTILS) dateUtils: IF360DateUtils) {
    this.dateUtils = dateUtils;

    this.shortcuts = new Map<
      EShortcutsDate<EShortcutsDateIndicadores>,
      IDateRange
    >([
      [
        EShortcutsDateIndicadores.acumulado30dias,
        this.dateUtils.accumulated30Days()
      ],
      [EShortcutsDateIndicadores.esteMes, this.dateUtils.thisMonth()],
      [EShortcutsDateIndicadores.mesPassado, this.dateUtils.lastMonth()],
      [EShortcutsDateIndicadores.ontem, this.dateUtils.yesterday()],
      [EShortcutsDateIndicadores.hoje, this.dateUtils.todayRange()],
      [EShortcutsDateIndicadores.ultimos7dias, this.dateUtils.lastSevenDays()],
      [
        EShortcutsDateIndicadores.proximos30Dias,
        this.dateUtils.nextThirtyDays()
      ],
      [
        EShortcutsDateIndicadores.ultimos90Dias,
        this.dateUtils.lastNinetyDays()
      ],

      [EShortcutsDateIndicadores.semanaPassada, this.dateUtils.lastweek()],
      [EShortcutsDateIndicadores.essaSemana, this.dateUtils.thisWeek()],
      [EShortcutsDateIndicadores.anoPassado, this.dateUtils.lastYear()],
      [EShortcutsDateIndicadores.esteAno, this.dateUtils.thisYear()],
      [EShortcutsDateIndicadores.ultimos12Meses, this.dateUtils.last12Months()],
      [
        EShortcutsDateIndicadores.proximos60Dias,
        this.dateUtils.proximos60Dias()
      ],
      [
        EShortcutsDateIndicadores.proximos90Dias,
        this.dateUtils.proximos90Dias()
      ],
      [
        EShortcutsDateIndicadores.proximos12Meses,
        this.dateUtils.proximos12Meses()
      ]
    ]);
    this.shortcutNames = [
      [EShortcutsDateIndicadores.ultimos7dias, "Últimos 7 dias"],
      [EShortcutsDateIndicadores.mesPassado, "Mês passado"],
      [EShortcutsDateIndicadores.esteMes, "Este mês"],
      [EShortcutsDateIndicadores.acumulado30dias, "Acumulado 30 dias"],
      [EShortcutsDateIndicadores.hoje, "Hoje"],
      [EShortcutsDateIndicadores.ontem, "Ontem"],
      [EShortcutsDateIndicadores.proximos30Dias, "Próximos 30 dias"],
      [EShortcutsDateIndicadores.ultimos90Dias, "Ultimos 90 dias"],

      [EShortcutsDateIndicadores.semanaPassada, "Semana passada"],
      [EShortcutsDateIndicadores.essaSemana, "Esta semana"],
      [EShortcutsDateIndicadores.anoPassado, "Ano passado"],
      [EShortcutsDateIndicadores.esteAno, "Este ano"],
      [EShortcutsDateIndicadores.ultimos12Meses, "Ultimos 12 meses"],

      [EShortcutsDateIndicadores.proximos60Dias, "Próximos 60 dias"],
      [EShortcutsDateIndicadores.proximos90Dias, "Próximos 90 dias"],
      [EShortcutsDateIndicadores.proximos12Meses, "Próximos 12 meses"]
    ];
  }

  handle(
    payload: EShortcutsDate<EShortcutsDateIndicadores>
  ): IDateRange | undefined {
    const rangeDate = this.shortcuts.get(payload) || undefined;

    return rangeDate;
  }
}
